import React from "react"

const HeadphoneIcon = (props) => {
    return (
    <svg width={70} height={70} viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle 
            cx="39.5" 
            cy="39.5" 
            r="39.5" 
            fill="#041025"
        />
        <path 
            d="M24.1584 33.0848C24.1584 28.9417 25.8042 24.9683 28.7338 22.0387C31.6634 19.1091 35.6368 17.4633 39.7798 17.4633C43.9229 17.4633 47.8963 19.1091 50.8259 22.0387C53.7555 24.9683 55.4013 28.9417 55.4013 33.0848V35.3945C59.1861 35.9368 62.0962 39.1927 62.0962 43.1271V43.685C62.0962 47.6462 58.6796 51.1186 54.6604 50.9334C53.009 55.6645 48.809 58.8535 44.2766 59.6613C43.2277 60.0452 41.9869 59.8644 40.8956 59.8644C40.0078 59.8644 39.1564 59.5117 38.5286 58.884C37.9009 58.2562 37.5482 57.4048 37.5482 56.517C37.5482 55.6292 37.9009 54.7777 38.5286 54.1499C39.1564 53.5222 40.0078 53.1695 40.8956 53.1695C42.6653 53.1695 44.6247 52.9129 45.8209 54.5286C48.7131 53.1516 50.938 50.2438 50.938 46.4746V33.0848C50.938 30.1254 49.7624 27.2873 47.6699 25.1947C45.5773 23.1022 42.7392 21.9266 39.7798 21.9266C36.8205 21.9266 33.9824 23.1022 31.8898 25.1947C29.7972 27.2873 28.6216 30.1254 28.6216 33.0848V47.0325C28.6216 48.0683 28.2102 49.0616 27.4778 49.794C26.7454 50.5264 25.752 50.9379 24.7163 50.9379C22.7927 50.9379 20.9479 50.1737 19.5877 48.8136C18.2276 47.4534 17.4634 45.6086 17.4634 43.685V43.1271C17.463 41.2486 18.1395 39.4328 19.3692 38.0126C20.5988 36.5923 22.2991 35.6629 24.1584 35.3945V33.0848Z" 
            fill="#F5F5F5"
        />
    </svg>
    )
}

export default HeadphoneIcon